import { getMetricOptions } from '../../../apis/graphql/reports/utils';
import {
  Frequency,
  ReportInput,
  ReportScheduleInput,
  StandardDeliveryDeviceHigherCategoryReport,
  StandardDeliveryReport,
  UpdateReportInput,
} from '../../../apis/graphql/types';
import { StaticFilters } from '../types/reports';
import { ReportFormValues } from './Shared';

const getInputSchedule = (reportFormValues: ReportFormValues): ReportScheduleInput => {
  return {
    emailNow: reportFormValues.emailNow,
    ...(reportFormValues.scheduleReport && {
      frequency: reportFormValues.frequency,
      days: reportFormValues.frequency === Frequency.Weekly ? reportFormValues.days : [],
    }),
  };
};

type Props = {
  templateId: string;
  filters: StaticFilters;
  reportFormValues: ReportFormValues;
  userId: string;
};
export const getReportInput = ({ templateId, filters, reportFormValues, userId }: Props): ReportInput => {
  return {
    ...getMetricOptions(templateId, filters),
    exportFormat: reportFormValues.format,
    name: reportFormValues.name,
    schedule: getInputSchedule(reportFormValues),
    ownerId: userId,
    recipients: reportFormValues.recipients,
  };
};

export const getUpdateReportInput = ({
  templateId,
  filters,
  reportFormValues,
}: Omit<Props, 'userId'>): UpdateReportInput => {
  const metricOptions = getMetricOptions(templateId, filters);

  return {
    dateRange: metricOptions.dateRange,
    startDate: metricOptions.startDate,
    endDate: metricOptions.endDate,
    exportFormat: reportFormValues.format,
    name: reportFormValues.name,
    schedule: getInputSchedule(reportFormValues),
    recipients: reportFormValues.recipients,
  };
};

export const getStaticFilters = (
  report: StandardDeliveryReport | StandardDeliveryDeviceHigherCategoryReport
): StaticFilters => {
  return {
    dateRange: report.dateRange,
    startDate: report.startDate || undefined,
    endDate: report.endDate || undefined,
    campaigns: report.filters.campaigns || [],
  };
};
